import AxiosClient from 'src/Services/AxiosClient';
import { SERVICE, COLLAB_ENV } from 'src/Config/constants';

const service = AxiosClient.getInstance();

//Get Native App details
export const getNativeAppDetails = async () => {
  const url = `${COLLAB_ENV}${SERVICE.COLLAB.GET_NATIVE_APP_DATA}`;
  return service.GetApiRequest(url);
};

//Get native app download url from software distribution portal via collab
export const getNativeAppDownloadUrl = async () => {
  const url = `${COLLAB_ENV}${SERVICE.COLLAB.GET_NATIVE_APP_DOWNLOAD_URL}`;
  return service.GetApiRequest(url);
};